module.exports = __webpack_public_path__ + "img/Banner640MathMastery.effffb02.png";